<div class="container-fluid">
  <div class="row">
    <div class="col-12 col-lg-6 offset-lg-3">
      <div class="card bg-white mt-6">
        <div class="card-body">
          <div class="badge bg-warning float-end">Update In Progress</div>
          <h2>Maintenance Mode</h2>
          <p>JetFuelTenders.com is currently undergoing scheduled maintenance. The platform will be available again shortly.</p>
          <p>For any questions, please contact us at <a
              href="mailto:info@jetfueltenders.com">info&#64;jetfueltenders.com</a></p>

          <a class="btn btn-outline-primary" href="/">Check Update Status</a>
        </div>
      </div>
    </div>
  </div>
</div>
